<div class="alumni-page">
  <app-header-style-seven></app-header-style-seven>

  <div class="custom-container">
    <section class="alumni-hero">
      <div class="hero-grid">
        <div class="hero-copy">
          <span class="hero-kicker">Career Development</span>
          <h1>{{ pageTitle }}</h1>
          <p>{{ pageSubtitle }}</p>
        </div>

        <div class="hero-stats">
          <div class="stat-card" *ngFor="let stat of heroStats">
            <span class="stat-label">{{ stat.label }}</span>
            <strong>{{ stat.value }}</strong>
          </div>
        </div>
      </div>
    </section>

    <section class="notice-bar" aria-label="Admission update">
      <div class="notice-label">Admissions Update</div>
      <div class="notice-track">
        <span>{{ admissionNotice }}</span>
      </div>
    </section>

    <section class="alumni-shell">
      <aside class="alumni-sidebar">
        <div class="sidebar-card">
          <span class="sidebar-kicker">Placement Menu</span>
          <h2>FMCET Placement Cell</h2>

          <div class="tab-list">
            <button
              *ngFor="let tab of tabs"
              type="button"
              class="tab-btn"
              [class.active]="selectedTab === tab.id"
              (click)="selectTab(tab.id)"
            >
              {{ tab.label }}
            </button>
          </div>
        </div>
      </aside>

      <main class="alumni-main">
        <section class="content-head-card">
          <span class="content-tag">Placement Services</span>
          <h2>{{ activeTabLabel }}</h2>
          <p>
            Fatima Michael College of Engineering &amp; Technology, Madurai.
          </p>
        </section>

        <ng-container [ngSwitch]="selectedTab">
          <!-- Overview -->
          <ng-container *ngSwitchCase="'tab1'">
            <section class="content-card">
              <div class="banner-image">
                <img
                  src="assets/img/page-title/p.png"
                  alt="Training and Placement Cell"
                />
              </div>

              <div class="section-copy">
                <h3>Training and Placement Cell</h3>
                <p *ngFor="let paragraph of overviewParagraphs">
                  {{ paragraph }}
                </p>

                <ul class="feature-list">
                  <li *ngFor="let item of overviewHighlights">
                    {{ item }}
                  </li>
                </ul>
              </div>
            </section>
          </ng-container>

          <!-- Statistics -->
          <ng-container *ngSwitchCase="'tab2'">
            <section class="content-card">
              <div class="section-head">
                <h3>Placement Statistics</h3>
                <p>Placement Highlights – Academic Year 2025–2026 (on-going)</p>
              </div>

              <div class="placement-metric-grid">
                <article class="placement-metric-card" *ngFor="let item of placementMetrics">
                  <span>{{ item.label }}</span>
                  <strong>{{ item.value }}</strong>
                </article>
              </div>

              <div class="section-copy placement-copy">
                <p *ngFor="let paragraph of statisticsParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>
          </ng-container>

          <!-- Training -->
          <ng-container *ngSwitchCase="'tab3'">
            <section class="content-card">
              <div class="section-head">
                <h3>Training and Support</h3>
                <p>Structured programmes that improve employability and placement readiness.</p>
              </div>

              <div class="section-copy">
                <p *ngFor="let paragraph of trainingParagraphs">
                  {{ paragraph }}
                </p>
              </div>

              <ul class="feature-list">
                <li *ngFor="let item of trainingHighlights">
                  {{ item }}
                </li>
              </ul>
            </section>
          </ng-container>

          <!-- Recruiters -->
          <ng-container *ngSwitchCase="'tab4'">
            <section class="content-card">
              <div class="section-head">
                <h3>Our Recruiters</h3>
                <p>Students from our institution have been placed in reputed organizations such as:</p>
              </div>

              <ul class="feature-list">
                <li *ngFor="let item of recruiters">
                  {{ item.sno }}. {{ item.companyName }}
                </li>
              </ul>

              <div class="section-copy placement-copy">
                <p>And many more emerging companies.</p>
              </div>
            </section>

            <section class="content-card">
              <div class="section-head">
                <h3>Offer Letter Highlights</h3>
                <p>Moments from student placement achievements.</p>
              </div>

              <div class="placement-photo-grid">
                <article class="placement-photo-card" *ngFor="let photo of recruiterPhotos">
                  <div class="placement-photo-media">
                    <img [src]="photo.image" [alt]="photo.alt" />
                  </div>
                  <div class="placement-photo-body">
                    <p>{{ photo.caption }}</p>
                  </div>
                </article>
              </div>
            </section>
          </ng-container>

          <!-- Internship -->
          <ng-container *ngSwitchCase="'tab5'">
            <section class="content-card">
              <div class="section-head">
                <h3>Internship</h3>
                <p>Industry exposure through active collaboration and MoU-supported opportunities.</p>
              </div>

              <div class="section-copy">
                <p *ngFor="let paragraph of internshipParagraphs">
                  {{ paragraph }}
                </p>
              </div>
            </section>
          </ng-container>

          <!-- Contact -->
          <ng-container *ngSwitchCase="'tab6'">
            <section class="content-card">
              <div class="section-head">
                <h3>Contact</h3>
                <p>For queries related to placements, internships, and recruitment support.</p>
              </div>

              <ul class="feature-list">
                <li><strong>Placement Coordinator:</strong> {{ contactName }}</li>
                <li><strong>Email:</strong> {{ contactEmail }}</li>
                <li><strong>Phone:</strong> {{ contactPhone }}</li>
              </ul>
            </section>
          </ng-container>
        </ng-container>
      </main>
    </section>

    <section class="bottom-cta">
      <article class="cta-card contact-card">
        <span class="cta-kicker">Placement Contact</span>
        <h3>Training and Placement Cell</h3>
        <p>
          Placement Cell,<br />
          Fatima Michael College of Engineering &amp; Technology,<br />
          Madurai.
        </p>
        <a class="text-link" href="mailto:placements@fmcet.ac.in">
          placements&#64;fmcet.ac.in
        </a>
      </article>

      <article class="cta-card action-card">
        <span class="cta-kicker">Career Support</span>
        <h3>Learn, Prepare, Get Placed</h3>
        <p>
          FMCET supports students through training, guidance, internships,
          recruiter engagement, and placement preparation activities.
        </p>
        <a href="mailto:placements@fmcet.ac.in" class="apply-button">
          Contact Placement Cell
        </a>
      </article>
    </section>
  </div>
</div>